export const money = (cents, cur = "eur") =>
  ((cents || 0) / 100).toLocaleString("nl-NL", { style: "currency", currency: (cur || "eur").toUpperCase() });

export const STATUS_STYLE = {
  beheer: "bg-indigo-50 text-indigo-700 border-indigo-200",
  vrij: "bg-teal-50 text-teal-700 border-teal-200",
  actief: "bg-emerald-50 text-emerald-700 border-emerald-200",
  proef: "bg-amber-50 text-amber-700 border-amber-200",
  verlopen: "bg-rose-50 text-rose-700 border-rose-200",
  friends_family: "bg-pink-50 text-pink-700 border-pink-200",
};

const STATUS_LABEL = { friends_family: "F&F" };

export function Badge({ status }) {
  return (
    <span className={`inline-block text-[11px] font-bold px-2 py-0.5 rounded-full border capitalize ${STATUS_STYLE[status] || "bg-slate-100 text-slate-600 border-slate-200"}`}>
      {STATUS_LABEL[status] || status}
    </span>
  );
}

export function Panel({ title, children, className = "", ...rest }) {
  return (
    <section className={`bg-white border border-slate-200 rounded-2xl p-5 shadow-sm ${className}`} {...rest}>
      {title && <h2 className="font-head font-bold text-sm text-slate-500 mb-4 tracking-wide uppercase">{title}</h2>}
      {children}
    </section>
  );
}
